import styled from 'styled-components';

type ContainerProps = {
  hasBorder: boolean;
  hasError: boolean;
  widthInput: string;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  width: 100%;
  max-height: 30rem;
  max-width: ${({ widthInput }) => widthInput || '20rem'};
  flex-direction: column;

  svg {
    fill: ${({ theme }) => theme.colors.primary};
  }

  .MuiInputBase-root {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: ${({ widthInput }) => widthInput || '20rem'};
    &:before,
    &:hover {
      border-bottom: ${({ hasBorder, theme, hasError }) =>
        hasBorder
          ? `1px solid ${hasError ? `${theme.colors.error_500}` : `${theme.colors.primary}`} `
          : 'none'} !important;
    }
  }
  .MuiSelect-root:hover {
    border-bottom: none;
  }

  .MuiMenuItem-root li {
    font-size: 1rem;
  }

  .placeholder {
    color: ${({ theme }) => theme.colors.text_gray};
    font-size: 1.3rem;
  }
  .fieldError {
    color: red;
    display: flex;
    align-items: center;
    font-size: 1rem;
    flex-wrap: nowrap;

    svg {
      margin-right: 2px;
      font-size: 1rem;
      padding-bottom: 0.1rem;
      fill: ${({ theme }) => theme.colors.error_500} !important;
    }
  }

  @media (max-width: 300px) {
    .MuiSelect-select {
      max-width: 17rem;
    }
  }
`;
